import { fromDynamicPricesDtoToModel } from 'src/Libs/dynamic-power-prices/api/dto/dynamic-price-settings.dto'
import { StorageStatusDto } from '../api/dto/storage.dto'
import { StorageStatusModel } from '../models/storage.models'
import fromPowermeterLiveDataDtoToModelTransformer from 'src/Libs/power-meters/transformer/from-live-data-dto-to-model.transformer'

export const fromStorageStatusDtoToModelTransformer = (dto: StorageStatusDto): StorageStatusModel => {
  return {
    powerAcL1: dto.POWER_AC_L1,
    powerAcL2: dto.POWER_AC_L2,
    powerAcL3: dto.POWER_AC_L3,
    powerBat1: dto.POWER_BAT_1,
    powerBat2: dto.POWER_BAT_2,
    powerBat3: dto.POWER_BAT_3,
    powerCL1: dto.POWER_C_L1,
    powerCL2: dto.POWER_C_L2,
    powerCL3: dto.POWER_C_L3,
    powerPvS1: dto.POWER_PV_S1,
    powerPvS2: dto.POWER_PV_S2,
    powerPvS3: dto.POWER_PV_S3,
    powerRootLmL1: dto.POWER_ROOTLM_L1,
    powerRootLmL2: dto.POWER_ROOTLM_L2,
    powerRootLmL3: dto.POWER_ROOTLM_L3,
    soc: dto.SOC,
    ip: dto.IP,
    systemStatus: dto.SYSSTATUS,
    powermeters: dto.powermeters?.map(fromPowermeterLiveDataDtoToModelTransformer),
    dataVersion: dto.dataVersion,
    offlineLevel: dto.offlineLevel,
    time: dto.time,
    dynamicPowerPrice: fromDynamicPricesDtoToModel(dto.dynamicPowerPrice),
  }
}
